import {alpha, Box, Chip, Popover, Tab, Tooltip, useTheme} from "@mui/material";
import Tabs, {tabsClasses} from "@mui/material/Tabs";
import React from "react";
import InfoLabel from "../Annotator/InfoLabel";

export default function AnnotatorChipsTab({labels, deletable, onDelete, maxWidth}) {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [currentLabel, setCurrentLabel] = React.useState(undefined);

    const handleClick = (event, label) => {
        setAnchorEl(event.currentTarget);
        setCurrentLabel(label);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? `chip-popover-${currentLabel.id}` : undefined;

    return (
        <Box sx={{
            bgcolor: 'background.paper',
            borderRadius: "0.2em",
            maxWidth: maxWidth,
        }}>
            <Tabs
                value={false}
                variant="scrollable"
                scrollButtons
                aria-label="labels chips"
                sx={{
                    [`& .${tabsClasses.scrollButtons}`]: {
                        '&.Mui-disabled': {opacity: 0.3},
                    },
                }}
            >
                {Array.isArray(labels) && labels.map((label) => (
                    <Tab
                        key={`annotator-chip-tab-${label.id}`}
                        value={label.id}
                        disableRipple
                        sx={{
                            "&.MuiTab-root": {
                                p: 1,
                                minWidth: "fit-content",
                            }
                        }}
                        label={
                            <Tooltip title={label.description ? label.description : ""}>
                                <Chip
                                    aria-describedby={id}
                                    size="small"
                                    sx={{
                                        "&.MuiChip-root": {
                                            color: theme => theme.palette.getContrastText(label.color),
                                            bgcolor: label.color ? label.color : "default",
                                            ":hover": {
                                                bgcolor: label.color ? alpha(label.color, 0.6) : "default",
                                            }
                                        },
                                        ".MuiChip-deleteIcon": {
                                            color: theme.palette.getContrastText(label.color),
                                            ":hover": {
                                                color: alpha(theme.palette.getContrastText(label.color), 0.6)
                                            }
                                        }
                                    }}
                                    label={label.label}
                                    onClick={(event) => handleClick(event, label)}
                                    onDelete={deletable ? () => onDelete(label) : undefined}
                                />
                            </Tooltip>
                        }
                    />
                ))}
            </Tabs>
            <Popover
                id={id}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <InfoLabel label={currentLabel}/>
            </Popover>
        </Box>
    );
}

AnnotatorChipsTab.defaultProps = {
    labels: [],
    maxWidth: "75vw"
}